import {Component, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {Incident} from '../../classes/incident.class';
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-new-incident-dialog',
    templateUrl: './new-incident-dialog.component.html',
    styleUrls: ['./new-incident-dialog.component.scss'],
    imports: [
        MatRadioGroup,
        MatRadioButton,
        FormsModule,
        MatButton,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions
    ]
})
export class NewIncidentDialogComponent implements OnInit {

    private readonly _badEffects = signal<boolean>(null);
    private readonly _nearBadEffects = signal<boolean>(null);
    private readonly _improvement = signal<boolean>(null);

    get badEffects(): boolean {
        return this._badEffects();
    }

    set badEffects(value: boolean) {
        this._badEffects.set(value);
    }

    get nearBadEffects(): boolean {
        return this._nearBadEffects();
    }

    set nearBadEffects(value: boolean) {
        this._nearBadEffects.set(value);
    }

    get improvement(): boolean {
        return this._improvement();
    }

    set improvement(value: boolean) {
        this._improvement.set(value);
    }

    constructor(
        public dialogRef: MatDialogRef<NewIncidentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public incident: Incident
    ) {
    }

    ngOnInit(): void {

    }

    badEffectsChange(event) {
        if (event.value) {
            this.incident.type = 'ongeval';
            this.dialogRef.close();
        }
    }

    differentConditions(event) {
        if (event.value) {
            this.incident.type = 'bijna-ongeval';
            this.dialogRef.close();
        }
    }

    complaint(event) {
        this.incident.type = 'verbeteridee';
        if (event.value) {
            this.incident.type = 'klacht';
            this.dialogRef.close();
        }
    }

    improve(event) {
        this.incident.type = 'overig';
        if (event.value) {
            this.incident.type = 'verbeteridee';
        }
        this.dialogRef.close();
    }

    onNoClick() {
        this.dialogRef.close();
    }
}
